import { render, staticRenderFns } from "./mktTable2.vue?vue&type=template&id=63613550&scoped=true&"
import script from "./mktTable2.vue?vue&type=script&lang=js&"
export * from "./mktTable2.vue?vue&type=script&lang=js&"
import style0 from "./mktTable2.scss?vue&type=style&index=0&id=63613550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63613550",
  null
  
)

export default component.exports